import React from 'react';

import CarouselSlider from '@/components/Carousel/Slider/Slider';
import GameLink from '@/components/GameLink';
import { ThemesCategoryItem } from '@/components/NavigationContent/types';
import SectionHeader from '@/components/SectionHeader/SectionHeader';

import styles from './Themes.module.scss';

interface MenuCategoryPropTypes {
  handleItemClick: (
    event: React.MouseEvent<HTMLAnchorElement | HTMLDivElement>,
    item: ThemesCategoryItem,
    containerTitle: string,
    theme_code: string
  ) => void;
  title?: string;
  items?: ThemesCategoryItem[];
}

const Themes: React.FC<MenuCategoryPropTypes> = ({
  items,
  handleItemClick,
  title = 'Themes',
}) => {
  if (!items || !items.length) return null;

  return (
    <>
      <SectionHeader heading={title} />
      <div className={styles.categoryWrapper} data-testid="menu-themes-wrapper">
        <CarouselSlider styleProp={'slider'} edgeSlidesPadding={7}>
          {items.map((item, index) => (
            <div
              data-testid="item"
              key={index}
              className={styles.wrapper}
              onClick={e =>
                handleItemClick(
                  e,
                  item,
                  title,
                  item.theme?.theme_code?.theme_code
                )
              }
            >
              <img
                data-testid="image"
                className={styles.icon}
                src={item.image?.source || ''}
                alt={item.image?.alt || ''}
              />
              <div className={styles.infoWrapper}>
                <h4 className={styles.title}>{item.description}</h4>
                <h5 className={styles.description}>{item.title}</h5>
              </div>
              {item.url && <GameLink url={item.url} target="_blank" />}
            </div>
          ))}
        </CarouselSlider>
      </div>
    </>
  );
};

export default Themes;
